import React, { useCallback, useContext, useEffect } from "react";
import { Button } from "@material-ui/core";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import OpenInBrowserIcon from "@material-ui/icons/OpenInBrowser";
import { useNavigate } from "react-router-dom";

import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { useEnroller } from "../../../../hooks";
import { AuthContext, UIContext } from "../../../../contexts";
import ProvidersGrid from "./providersGrid/ProvidersGrid";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";

import "./providers.scss";
import { getPermissionsFromGroupOwner } from "../../../../utils/getPermissionsFromGroupOwner";
import useRouteParam from "../../../../hooks/useRouteParam";

const Providers: React.FC = (): JSX.Element => {
	const { setDashboardHeader } = useContext(UIContext);
	const { isEnroller } = useEnroller();
	const navigate = useNavigate();

	const queryGroupNumber = useRouteParam("gn");
	const { user, setUser } = useContext(AuthContext);

	const providersPermission = user
		? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.providers_menu.self
		: null;

	const handleRedirectToCreationPage = useCallback(
		(redirectionPath: "BULK-UPLOAD" | "ADD-PROVIDERS" | "UPDATE-PROVIDERS") => {
			if (redirectionPath === "BULK-UPLOAD") navigate("/employer/providers/add-providers-bulk-upload?gn=220");
			if (redirectionPath === "ADD-PROVIDERS") navigate("/employer/providers/add-providers?gn=220");
			if (redirectionPath === "UPDATE-PROVIDERS")
				navigate("/employer/providers/update-provider-by-tax-id?gn=220");
		},
		[navigate]
	);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.providers);
	}, [setDashboardHeader]);

	return (
		<div className="providers-main-container">
			{isEnroller ? null : (
				<div className="pf-action-button-container" id="pf-action-button-container">
					{providersPermission && providersPermission.update && (
						<Button
							className="button-green"
							variant="contained"
							onClick={() => handleRedirectToCreationPage("UPDATE-PROVIDERS")}
						>
							<span className="button-label-with-icon">Update Providers (Tax-ID)</span>
							<span>
								<SystemUpdateAltIcon className="button-icon" />
							</span>
						</Button>
					)}
					{providersPermission && providersPermission.create && (
						<Button
							className="button-black"
							variant="contained"
							onClick={() => handleRedirectToCreationPage("BULK-UPLOAD")}
						>
							<span className="button-label-with-icon">Providers Bulk Upload</span>
							<span>
								<OpenInBrowserIcon className="button-icon" />
							</span>
						</Button>
					)}
					{providersPermission && providersPermission.create && (
						<Button
							className="button-green"
							variant="contained"
							onClick={() => handleRedirectToCreationPage("ADD-PROVIDERS")}
						>
							<span className="button-label-with-icon">Add Providers</span>
							<span>
								<GroupAddIcon className="button-icon" />
							</span>
						</Button>
					)}
				</div>
			)}
			<div className="pf-title">Listed Providers</div>
			{providersPermission && providersPermission.view ? <ProvidersGrid /> : null}
		</div>
	);
};

export default Providers;
